"use strict";

const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");

// load font via webpack asset/resource
// require("src/tokens/index.css");

function _clear () {
    this.innerHTML = "";
}

class Button extends HTMLElement {
    constructor(template) {
        super(template);

        this.root = this.attachShadow({ mode: "open" });

        const content = template ? template.content.cloneNode(true) : baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);
        this.href = this.getAttribute("href");
        if (this.href) {
            this.button = document.createElement("a");
            this.button.setAttribute("href", this.href);
            this.button.setAttribute("rel", "noopener");
            if (this.hasAttribute("external")) {
                this.button.setAttribute("target", "_blank");
            }
        } else {
            this.button = document.createElement("button");
        }

        _clear.bind(this);
    }


    connectedCallback() {

        this.button.className = "swiftref-button";
        if (this.hasAttribute("disabled")) {
            this.button.setAttribute("disabled", "");
        }
        this.root.appendChild(this.button);

        if (this.innerHTML) {
            this.button.innerHTML = this.innerHTML;
            this.button.setAttribute("aria-label", `${this.button.textContent} button`);
        }
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(_clear, 1);

    }

    // see https://carbondesignsystem.com/components/button/usage
    static get observedAttributes() {
        return ["disabled", "label"];
    }

    attributeChangedCallback(name, oldVal, newVal) {
        if (name === "disabled") {
            if (this.disabled) {
                this.button.setAttribute("disabled", "");
            } else {
                this.button.removeAttribute("disabled");
            }
        }
        // used to change the Button label after it has been instantiated
        else if (name === "label") {
            this.button.innerHTML = newVal;
            this.button.setAttribute("aria-label", `${this.button.textContent} button`);
        }
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(disabled) {
        this.setAttribute("disabled", "");
    }

}

window.customElements.define("swiftref-button", Button);

module.exports = Button;
